const icon = require('vue-svgicon');
icon.register({
    'telegram-round': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M16 0C7.168 0 0 7.168 0 16s7.168 16 16 16 16-7.168 16-16S24.832 0 16 0zm7.424 10.88c-.24 2.528-1.28 8.672-1.808 11.504-.224 1.2-.672 1.6-1.088 1.648-.928.08-1.632-.608-2.528-1.2-1.408-.928-2.208-1.504-3.568-2.4-1.584-1.04-.56-1.616.352-2.544.24-.24 4.336-3.968 4.416-4.304a.32.32 0 00-.08-.288c-.096-.08-.224-.048-.336-.032-.144.032-2.384 1.52-6.752 4.464-.64.432-1.216.656-1.728.64-.576-.016-1.664-.32-2.48-.592-1.008-.32-1.792-.496-1.728-1.056.032-.288.432-.576 1.184-.88 4.672-2.032 7.776-3.376 9.328-4.016 4.448-1.856 5.36-2.176 5.968-2.176.128 0 .432.032.624.192.16.128.208.304.224.432-.016.096.016.384 0 .608z" _fill="#fff"/>`,
    },
});
